import { render } from "./Forms.vue?vue&type=template&id=55517693&scoped=true&ts=true"
import script from "./Forms.vue?vue&type=script&lang=ts"
export * from "./Forms.vue?vue&type=script&lang=ts"

import "./Forms.vue?vue&type=style&index=0&id=55517693&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55517693"]])

export default __exports__